
import PasswordReseted from "@/components/modal/PasswordReseted.vue";
import MiniTopBar from "@/components/topBar/MiniTopBar.vue";
import TopBar from "@/components/topBar/TopBar.vue";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    TopBar,
    MiniTopBar,
    PasswordReseted,
  },
  props: {
    token: {
      type: String,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      newPassword: "",
      confirmPassword: "",
      wrongPassword: false,
      showPasswordResetedModal: false,
      error: false,
      errorMsg: "",
    };
  },
  methods: {
    checkPassword() {
      if (this.confirmPassword !== this.newPassword) {
        this.wrongPassword = true;
        this.newPassword = "";
        this.confirmPassword = "";
        return false;
      }
      this.wrongPassword = false;
      return true;
    },
    async updatePassword() {
      if (!this.checkPassword()) return;
      const response = await axios.patch(
        "users/" + this.id + "/resetpassword",
        {
          token: this.token,
          password: this.newPassword,
        }
      );

      if (response.status === 401) {
        this.error = true;
        this.errorMsg = "Le lien a expiré";
        return;
      }
      if (response.status === 400) {
        this.error = true;
        this.errorMsg = "Le lien est incorrect";
        return;
      }
      if (response.status >= 300) {
        this.error = true;
        this.errorMsg = "Une erreur s'est produite";
        return;
      }
      this.error = false;
      this.errorMsg = "";
      this.togglePasswordResetedModal();
    },
    togglePasswordResetedModal() {
      this.showPasswordResetedModal = !this.showPasswordResetedModal;
    },
  },
});
